export default __webpack_public_path__ + "static/media/violet-ball-inverted.6789badb.svg";